var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    id: "e6_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 80,
    x2: 100,
    y2: 0,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    id: "e7_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 100,
    x2: 100,
    y2: 20,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    id: "e8_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 100,
    x2: 100,
    y2: 100,
    y1: 80
  }), /*#__PURE__*/React.createElement("line", {
    id: "e9_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 100,
    x2: 80,
    y2: 100,
    y1: 100
  }), /*#__PURE__*/React.createElement("line", {
    id: "e10_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 20,
    x2: 0,
    y2: 100,
    y1: 100
  }), /*#__PURE__*/React.createElement("line", {
    id: "e11_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 0,
    x2: 0,
    y2: 80,
    y1: 100
  }), /*#__PURE__*/React.createElement("line", {
    id: "e12_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 0,
    x2: 0,
    y2: 0,
    y1: 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "e13_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 0,
    x2: 20,
    y2: 0,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    id: "e20_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 40,
    x2: 60,
    y2: 50,
    y1: 50
  }), /*#__PURE__*/React.createElement("line", {
    id: "e21_line",
    style: {
      stroke: "white",
      fill: "none",
      strokeWidth: 1
    },
    x1: 50,
    x2: 50,
    y2: 60,
    y1: 40
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.16cbb43c.svg";
export { ForwardRef as ReactComponent };